import Plyr from 'plyr/dist/plyr.polyfilled.js';

export default {

  plyr: {

    init(selector = '.plyr-embed') {
      const plyrs = document.querySelectorAll(selector);

      if ( plyrs.length ) {
        Array.from(plyrs).map(player => new Plyr(player));
      }
    },

  },

}

